<script src="https://code.jquery.com/jquery-3.5.1.min.js"></script>
<div *ngIf="resultPresent">
  <div class="searchResults">
    <div class="searchResultsPresent">
      <div class="accordions w-100">
        <div
          class="accordion"
          *ngFor="let item of searchResult.products"
          [ngClass]="{ selected: false }"
        >
          <div class="accordion-header" (click)="toggleAccordion(item)">
            <h3 class="accordion-title">{{ item.title }}</h3>

            <span class="accordion-icon">{{ item.selected ? "-" : "+" }}</span>
          </div>

          <div class="accordion-content" *ngIf="item.selected">
            <div class="content-data" [innerHTML]="item.content"></div>
            <div *ngFor="let item of item.contentDocuments; let i = index">
              <div>
                <a
                  *ngIf="item.type == 'PAGE_LINK'"
                  href="{{ item.url }}"
                  target="_blank"
                  class="linkText"
                  >{{ item.linkText }}</a
                >
              </div>
            </div>

            <h1 *ngIf="showHeading(item?.contentDocuments)">
              <p class="resources-text">Resources</p>
            </h1>

            <div *ngFor="let item of item.contentDocuments; let i = index">
              <h1
                *ngIf="
                  item.type == 'PDF' ||
                  item.type == 'YOUTUBE_VIDEO' ||
                  item.type == 'VIDEO'
                "
              >
                <p
                  class="resources-text"
                  *ngIf="item.type == 'YOUTUBE_VIDEO' || item.type == 'VIDEO'"
                >
                  {{ item.linkText }}
                </p>
              </h1>
              <div>
                <div
                  class="document-info d-flex flex-wrap justify-content-between"
                  *ngIf="item.type == 'PDF'"
                >
                  <a
                    *ngIf="item.type == 'PDF'"
                    href="{{ item.url }}"
                    target="_blank"
                    class="linkText"
                    >{{ item.linkText }}</a
                  >
                  <a href="{{ item.url }}" class="viewAllText" target="_blank"
                    >View
                    <img
                      src="../../../assets/icons/viewIconNew.svg"
                      width="15"
                      height="20"
                  /></a>
                </div>
              </div>

              <div class="youtube_video" *ngIf="item.type == 'YOUTUBE_VIDEO'">
                <iframe
                  width="345"
                  class="iframe-youtube"
                  allowfullscreen=""
                  height="194"
                  [attr.src]="item?.url | safe : 'resourceUrl'"
                >
                </iframe>
              </div>

              <div class="youtube_video" *ngIf="item.type == 'VIDEO'">
                <iframe
                  width="345"
                  class="iframe-youtube"
                  allowfullscreen=""
                  height="194"
                  [attr.src]="item?.url | safe : 'resourceUrl'"
                >
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
